const THEME = {
  // the default breakpoints
  breakpoints: ['40em', '52em', '64em'],
};

export default THEME;
